import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class XmlToJsonService {
  constructor() {}

  private fieldMapping = {
    lotNo: 'formData',
    warrantyType: 'formType',
    deficiency: {
      description: 'description',
      location: 'location',
      level: 'level',
      room: 'room',
      category: 'category',
      item: 'item'
      // numbers: 'numbers'
    }
  };

  // List of all form types to check
  private formTypes = [
    'airConditioningForm',
    'dcdoForm',
    'emergencyForm',
    'initialForm',
    'midYearForm',
    'msdForm',
    'secondYearForm',
    'thirtyDayForm',
    'yearEndForm'
  ];

  processXmlData(xmlData: any) {
    if (!xmlData || !xmlData.ArrayOfVBIResult || !xmlData.ArrayOfVBIResult.VBIResult) {
      return [];
    }

    let vbiResults = xmlData.ArrayOfVBIResult.VBIResult;
    if (!Array.isArray(vbiResults)) {
      vbiResults = [vbiResults];
    }

    return vbiResults.map((result: any) => {
      const formData = result.formData || {};
      // Extract just the value from formType, ignoring the $ and xmlns properties
      const formType = result[this.fieldMapping.warrantyType]
        ? typeof result[this.fieldMapping.warrantyType] === 'object'
          ? result[this.fieldMapping.warrantyType]._ || null
          : result[this.fieldMapping.warrantyType]
        : null;

      // Extract lotNumber by checking all forms
      let lotNumber = null;
      for (const formType of this.formTypes) {
        if (formData[formType]?.homeIdentInfo?.addresstype?.lotNumber) {
          lotNumber = formData[formType].homeIdentInfo.addresstype.lotNumber;
          break;
        }
      }

      // Check for outstandingItems in all forms
      let outstandingItems = null;
      for (const formType of this.formTypes) {
        if (formData[formType]?.outstandingItems?.outstandingItem) {
          outstandingItems = formData[formType].outstandingItems.outstandingItem;
          break;
        }
      }

      // Ensure outstandingItems is always an array
      const items = Array.isArray(outstandingItems) ? outstandingItems : outstandingItems ? [outstandingItems] : [];

      return {
        lotNo: lotNumber,
        warrantyType: formType,
        deficiencies: items.map((item: any) => {
          if (!item)
            return {
              description: null,
              location: null,
              level: null,
              room: null,
              category: null,
              item: null
            };

          return {
            description: item[this.fieldMapping.deficiency.description] || null,
            location: item[this.fieldMapping.deficiency.location] || null,
            level: item[this.fieldMapping.deficiency.level]
              ? typeof item[this.fieldMapping.deficiency.level] === 'object'
                ? item[this.fieldMapping.deficiency.level]._ || null
                : item[this.fieldMapping.deficiency.level]
              : null,
            room: item[this.fieldMapping.deficiency.room]
              ? typeof item[this.fieldMapping.deficiency.room] === 'object'
                ? item[this.fieldMapping.deficiency.room]._ || null
                : item[this.fieldMapping.deficiency.room]
              : null,
            category: item[this.fieldMapping.deficiency.category]
              ? typeof item[this.fieldMapping.deficiency.category] === 'object'
                ? item[this.fieldMapping.deficiency.category]._ || null
                : item[this.fieldMapping.deficiency.category]
              : null,
            item: item[this.fieldMapping.deficiency.item]
              ? typeof item[this.fieldMapping.deficiency.item] === 'object'
                ? item[this.fieldMapping.deficiency.item]._ || null
                : item[this.fieldMapping.deficiency.item]
              : null
          };
        })
      };
    });
  }

  // processXmlData(xmlData: any) {
  //   let vbiResults = xmlData.ArrayOfVBIResult.VBIResult;
  //   if (!Array.isArray(vbiResults)) {
  //     vbiResults = [vbiResults];
  //   }

  //   return vbiResults.map((result: any) => {
  //     const formData = result.formData;
  //     // Extract just the value from formType and enrolmentNumber, ignoring the $ and xmlns properties
  //     const formType = typeof result[this.fieldMapping.warrantyType] === 'object'
  //       ? result[this.fieldMapping.warrantyType]._
  //       : result[this.fieldMapping.warrantyType];
  //     const enrolmentNumber = typeof result[this.fieldMapping.lotNo] === 'object'
  //       ? result[this.fieldMapping.lotNo]._
  //       : result[this.fieldMapping.lotNo];
  //     const outstandingItems = formData.msdForm?.outstandingItems?.outstandingItem ||
  //                            formData.secondYearForm?.outstandingItems?.outstandingItem || [];

  //     // Ensure outstandingItems is always an array
  //     const items = Array.isArray(outstandingItems) ? outstandingItems : [outstandingItems];

  //     return {
  //       lotNo: enrolmentNumber,
  //       warrantyType: formType,
  //       deficiencies: items.map((item: any) => ({
  //         description: item[this.fieldMapping.deficiency.description],
  //         location: item[this.fieldMapping.deficiency.location],
  //         level: typeof item[this.fieldMapping.deficiency.level] === 'object'
  //           ? item[this.fieldMapping.deficiency.level]._
  //           : item[this.fieldMapping.deficiency.level],
  //         room: typeof item[this.fieldMapping.deficiency.room] === 'object'
  //           ? item[this.fieldMapping.deficiency.room]._
  //           : item[this.fieldMapping.deficiency.room],
  //         category: typeof item[this.fieldMapping.deficiency.category] === 'object'
  //           ? item[this.fieldMapping.deficiency.category]._
  //           : item[this.fieldMapping.deficiency.category],
  //         // numbers: item[this.fieldMapping.deficiency.numbers]
  //       }))
  //     };
  //   });
  // }
}
